import React, { useState, useEffect } from "react";
import Gallery from 'react-image-gallery'; // Import the gallery component
import 'react-image-gallery/styles/css/image-gallery.css';
import { useParams } from "react-router-dom";
import { fetchData } from "../../Components/common/utils";
import MainLoader from "../../Components/MainLoader";
import BookingModal from "../../Components/BookingModal";
function BikeVariantDetail() {
    const [data, setData] = useState([]);
    const [bikeSpecification, setBikeSpecification] = useState({});
    const [imagesList, setImagesList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [productName, setProductName] = useState('');
    const { id } = useParams();
    useEffect(() => {
        const fetchApiData = async () => {
            const url = "api/bike/specification/" + id;
            const result = await fetchData(url);
            if (result && result.data) {

                if (result.data?.bike_specification) {
                    setBikeSpecification(result.data?.bike_specification)
                } else {
                    setBikeSpecification(result.data.bike_product?.bike_specification)
                }
                if (result.data.variant === null) {
                    setProductName(result.data.bike_product.title)
                    const images = result.data.bike_product?.media.map(item => ({
                        original: item.original_url,
                        thumbnail: item.original_url
                    }));
                    setImagesList(images)
                } else {
                    setProductName(result.data.variant.title)
                    const images = result.data.variant?.media.map(item => ({
                        original: item.original_url,
                        thumbnail: item.original_url
                    }));
                    setImagesList(images)
                }
                setData(result.data);
            }
            setLoading(false);
        };
        fetchApiData();
    }, [id]);
    const responsive = [
        {
            breakpoint: 1024, // Tablets and large mobile devices
            settings: {
                slidesToShow: 3,  // Display 3 images at a time on medium screens
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768, // Small devices (e.g. mobile phones)
            settings: {
                slidesToShow: 1,  // Show 1 image at a time on mobile screens
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480, // Very small screens
            settings: {
                slidesToShow: 1,  // Show 1 image at a time on very small screens
                slidesToScroll: 1,
            },
        },
    ];
    return (
        <div className="container my-5">
            {loading && <MainLoader />}
            <div className="mt-4">
                {/* Modern Header */}
                <div className="brand-banner py-5 px-3 text-center text-white mb-4">
                    <h1 className="display-4 fw-bold mb-2"><span className="brand-name">{productName}</span></h1>
                    <p className="lead">{data?.bike_product?.description}</p>
                </div>
            </div>
            <div className="row mt-3 bg-light p-2">
                <div className="col-md-8 p-2">
                    <Gallery items={imagesList} autoPlay={false} responsive={responsive} />
                </div>
                <div className="col-md-4">
                    <div className="rounded d-flex theme-light-bg align-items-center py-4 px-3">
                        <svg width="60px" height="60px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="#e4212b"/>
                            <path d="M7.5 12.5l3 1.5 2.5-5.5 2.5 3.5 2-1" stroke="#e4212b" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                            <circle cx="7.5" cy="12.5" r="1.2" fill="#e4212b"/>
                            <circle cx="17.5" cy="10.5" r="1.2" fill="#e4212b"/>
                        </svg>
                        <div className="ms-5">
                            <h6>Range (KM/Charge)</h6>
                            <p className="mb-0">{bikeSpecification?.range_per_charge}</p>
                        </div>
                    </div>
                    <div className=" border-top theme-light-bg rounded d-flex  align-items-center py-4 px-3">
                        <svg width="60px" height="60px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="2" y="7" width="18" height="10" rx="2" stroke="#da232c" strokeWidth="2" fill="none"/>
                            <rect x="4" y="9" width="12" height="6" rx="1" fill="#da232c"/>
                            <path d="M20 10h2v4h-2" stroke="#da232c" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                        <div className="ms-5">
                            <h6>Battery (V/Ah)</h6>
                            <p className="mb-0">{bikeSpecification?.battery_capacity}</p>
                        </div>
                    </div>
                    <div className=" border-top rounded d-flex theme-light-bg align-items-center py-4 px-3">
                        <svg width="60px" height="60px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" fill="#e5202b"/>
                        </svg>
                        <div className="ms-5">
                            <h6>Motor (Watts)</h6>
                            <p className="mb-0">{bikeSpecification?.motor_power}</p>
                        </div>
                    </div>
                    <div className=" border-top rounded d-flex theme-light-bg align-items-center py-4 px-3">
                        <svg width="60px" height="60px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 3C7.03 3 3 7.03 3 12s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" fill="#f2232d"/>
                            <path d="M12 7v5l3.5 2.1-.9 1.5L10.5 13V7H12z" fill="#f2232d"/>
                            <circle cx="12" cy="12" r="1.5" fill="#f2232d"/>
                        </svg>
                        <div className="ms-5">
                            <h6>Top Speed (Km/h)</h6>
                            <p className="mb-0">{bikeSpecification?.top_speed}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-5 varient-detail">

                <div class="title-wrapper d-flex mb-30">
                    <h4 class="mb-0 flex-shrink-0"> Engine and Performance</h4>
                    <span class="spacer align-self-end ms-3"></span>
                </div>
                {/* <div style={{ overflow: 'scroll' }} className="teble-td-inherit">
                    <table class="table table-bordered rounded mt-3 ">
                        <tbody>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Motor Power</p>
                                        <p className="pb-0 mb-0">{bikeSpecification?.motor_power}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Top Speed</p>
                                        <p className="pb-0 mb-0">{bikeSpecification?.top_speed}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Battery Capacity</p>
                                        <p className="pb-0 mb-0">{bikeSpecification?.battery_capacity}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Range Per Charge</p>
                                        <p className="pb-0 mb-0">{bikeSpecification?.range_per_charge}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Charging Time</p>
                                        <p className="pb-0 mb-0">{bikeSpecification?.charging_time}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Frame Material</p>
                                        <p className="pb-0 mb-0">{bikeSpecification?.frame_material}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Wheel Size</p>
                                        <p className="pb-0 mb-0">{bikeSpecification?.wheel_size}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Bike Weight</p>
                                        <p className="pb-0 mb-0">{bikeSpecification?.bike_weight}</p>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Load Capacity</p>
                                        <p className="pb-0 mb-0">{bikeSpecification?.load_capacity}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Brake Type</p>
                                        <p className="pb-0 mb-0">{bikeSpecification?.brake_type}</p>
                                    </div>
                                </td>
                            </tr> <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Suspension</p>
                                        <p className="pb-0 mb-0">{bikeSpecification?.suspension}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Ground Clearance</p>
                                        <p className="pb-0 mb-0">{bikeSpecification?.gears}/{bikeSpecification?.assist_modes}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">App Connectivity</p>
                                        <p className="pb-0 mb-0">{bikeSpecification?.app_connectivity}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Water Resistence Rating</p>
                                        <p className="pb-0 mb-0">{bikeSpecification?.water_resistance_rating}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Foldable</p>
                                        <p className="pb-0 mb-0">{bikeSpecification?.foldable === 0 ? 'No' : 'Yes'}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Lighting</p>
                                        <p className="pb-0 mb-0">{bikeSpecification?.lighting}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Display Type</p>
                                        <p className="pb-0 mb-0">{bikeSpecification?.display_type}</p>
                                    </div>
                                </td>
                              
                            </tr>
                        </tbody>
                    </table>
                </div> */}
                <div className="row gy-3 mt-3">

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Motor Power</p>
                            <p className="mb-0">{bikeSpecification?.motor_power}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Top Speed</p>
                            <p className="mb-0">{bikeSpecification?.top_speed}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Battery Capacity</p>
                            <p className="mb-0">{bikeSpecification?.battery_capacity}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Range Per Charge</p>
                            <p className="mb-0">{bikeSpecification?.range_per_charge}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Charging Time</p>
                            <p className="mb-0">{bikeSpecification?.charging_time}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Frame Material</p>
                            <p className="mb-0">{bikeSpecification?.frame_material}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Wheel Size</p>
                            <p className="mb-0">{bikeSpecification?.wheel_size}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Bike Weight</p>
                            <p className="mb-0">{bikeSpecification?.bike_weight}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Load Capacity</p>
                            <p className="mb-0">{bikeSpecification?.load_capacity}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Brake Type</p>
                            <p className="mb-0">{bikeSpecification?.brake_type}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Suspension</p>
                            <p className="mb-0">{bikeSpecification?.suspension}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Ground Clearance</p>
                            <p className="mb-0">{bikeSpecification?.gears}/{bikeSpecification?.assist_modes}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">App Connectivity</p>
                            <p className="mb-0">{bikeSpecification?.app_connectivity}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Water Resistance Rating</p>
                            <p className="mb-0">{bikeSpecification?.water_resistance_rating}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Foldable</p>
                            <p className="mb-0">{bikeSpecification?.foldable === 0 ? 'No' : 'Yes'}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Lighting</p>
                            <p className="mb-0">{bikeSpecification?.lighting}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Display Type</p>
                            <p className="mb-0">{bikeSpecification?.display_type}</p>
                        </div>
                    </div>

                </div>

                <div className="mt-4 d-flex justify-content-between  text-end">
                    <BookingModal ProductDetail={data} />
                    <h3>Price : {data?.bike_product?.price_range ? data?.bike_product?.price_range : data?.bike_product?.price_start}</h3>
                </div>
            </div>
        </div>
    )
}

export default BikeVariantDetail;